import { mapActions } from 'vuex';

export default {
  created() {
    this.getMasters('lokakarya_kegiatan_psp;lokakarya_moda_psp');
  },

  methods: {
    ...mapActions('lokakarya', ['fetch', 'create', 'update', 'delete', 'getDetail']),
    ...mapActions('master', ['getMasters']),

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign(
          {},
          this.params,
          { gelombang: this.gelombang },
          { tahun_ke: this.tahunKe },
          this.$isObject(this.filters) ? this.filters : {}
        );
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then((resp) => {
          this.data = resp?.data || [];
          this.total = resp?.total || 0;
          this.pageTotal = resp?.last_page || 1;
          this.params.limit = resp?.per_page || this.params.limit;
          resolve(true);
        });
      });
    },

    onChangeGelombang(value) {
      const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
      this.gelombang = value;
      this.tahunKe = tahunKe[value];
      this.onReload();
    },

    onChangeTahun(value) {
      this.tahun_ke = value;
      this.onReload();
    },

    onAdd() {
      this.$set(this.formulir, 'form', 'FormKelompok');
      this.$set(this.formulir, 'title', 'Laporan Pendampingan Kelompok');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'isEdit', false);
      this.$set(this.formulir, 'id', null);
      this.$set(this.formulir, 'useSave', true);
      this.$set(this.formulir, 'readOnly', false);
      this.$set(this.formulir, 'isPelapor', false);

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onEdit(item, readonly = false) {
      const resp = await this.getDetail({ id: this.$getDeepObj(item, 'psp_kp_lokakarya_id') }).then(({ data }) => data);
      this.$set(this.formulir, 'form', 'FormKelompok');
      this.$set(this.formulir, 'title', 'Laporan Pendampingan Kelompok');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'isEdit', true);
      this.$set(this.formulir, 'detail', resp);
      this.$set(this.formulir, 'id', this.$getDeepObj(item, 'psp_kp_lokakarya_id'));
      this.$set(this.formulir, 'useSave', !readonly && this.$allow('psp-peserta-kp-lokakarya.update'));
      this.$set(this.formulir, 'readOnly', readonly);
      this.$set(this.formulir, 'isPelapor', readonly);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', resp);
      });
    },

    onDetail(item) {
      if ((+item.gelombang === 1 && +item.tahun_ke === 1) || !item.tahun_ke) {
        this.onEdit(item, true);
        return;
      }

      this.$router.push({
        name: 'detail-pendampingan-lokakarya',
        params: { psp_kp_pa_id: item.psp_kp_pa_id },
      });
    },

    onSave() {
      const params = this.$refs.formulir.getValue();
      const validate = this.$refs.formulir.validate();
      const isEdit = this.formulir.isEdit;
      const id = this.formulir.id;

      if (!validate) {
        this.$refs.modal.loading = false;
        return;
      }

      this[isEdit ? 'update' : 'create']({ id: id, params: params })
        .then(() => {
          this.$success(`Laporan pendampingan kelompok berhasil ${isEdit ? 'diperbarui' : 'ditambahkan'}`);
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelete(item) {
      this.$confirm('Apakah anda yakin ingin menghapus data berikut ?', `Peringatan`, {
        tipe: 'error',
      }).then(() => {
        this.delete({ id: this.$getDeepObj(item, 'psp_kp_lokakarya_id') }).then(() => {
          this.$success('Data kelompok berhasil di hapus');
          this.onReload();
        });
      });
    },
  },
};
